export default __webpack_public_path__ + "static/media/authendication.d752d3a8.svg";